import {
   CurrentDoctorSimpleQuery,
   DoctorSimple,
   DoctorSimpleFromCurrentHealthcareProviderQuery,
} from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsFind, useCqrsSearch } from '@dreryk/command-query-react-common';
import { TranslatableText } from '@dreryk/react-common';
import { Message, MessageType } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { useResourceBranchByHealthcareProviderType } from '~libs.shared.account';

import { PageLoader } from '../common/PageLoader';
import { personnelTranslationKeys } from '../translations';

type SchedulePanelLoaderRenderProps = {
   doctors: DoctorSimple[];
   currentDoctor: DoctorSimple | null;
};

type SchedulePanelLoaderProps = {
   readonly children: (renderProps: SchedulePanelLoaderRenderProps) => JSX.Element;
};

export const SchedulePanelLoader = (props: SchedulePanelLoaderProps): JSX.Element => {
   const searchingDoctorsAvailable = protectFeature('searchingAllPractitioners');

   const { data: currentDoctor, loading: currentDoctorLoading, error: currentDoctorError } = useCqrsFind<DoctorSimple>(
      () => new CurrentDoctorSimpleQuery(),
      { enabled: !searchingDoctorsAvailable }
   );

   const { data: doctors, loading: doctorsLoading, error: doctorsError } = useCqrsSearch<DoctorSimple>(
      () => new DoctorSimpleFromCurrentHealthcareProviderQuery()
   );

   const errorMessage = useResourceBranchByHealthcareProviderType<TranslatableText, TranslatableText>(
      personnelTranslationKeys.doctorsFetchErrorOrganization,
      personnelTranslationKeys.doctorFetchErrorPractice
   );

   if (doctorsLoading || currentDoctorLoading) {
      return <PageLoader />;
   }

   if (doctorsError || currentDoctorError) {
      return <Message testId={'error'} type={MessageType.NEGATIVE} label={errorMessage} />;
   }

   return props.children({ doctors: doctors, currentDoctor: currentDoctor });
};
